import { PartnerProfileCompleteness, PartnersInformation } from '../domain/partners.model';
import { ApiEndpointService } from './api-endpoint.service';


import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import {
  Observable,
  throwError
} from "rxjs";
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  tap
} from "rxjs/operators";
import { ToastAlertService } from "src/app/shared/utils/toast.service";
// import { ApiEndpointService } from "./api-endpoint.service";
import * as ProfileActions from "src/app/core/state/profile/profile.action";
import * as CorporateDashboardAction from 'src/app/core/state/corporate-dashboard/corporate.dashboard.action';
import { getProfileData } from "../state/profile";
import { IProfileDetails } from "../domain/profile.model";
import { GlobalService } from "./global.service";
import { IAddPartnerStartup, PartnerInformationModel } from '../domain';
import * as PartnerDashboardAction from 'src/app/core/state/partner-dashboard/partner.dashboard.action';

import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { getBrandDetails } from '../state/global';
import { AuthService } from './auth.service';
import { httpFaultMessage } from 'src/app/shared/utils/http-fault.util';
interface ContactFormInfo {
  name: string,
  emailAddress: string,
  mobileNumber: string,
  companyName: string,
  website: string
}

@Injectable({
  providedIn: 'root'
})
export class PartnersService {
  profileData: IProfileDetails;

  constructor(private http: HttpClient, private toastService: ToastAlertService, private store: Store, private globalService: GlobalService,
    private router: Router,
    private authService: AuthService) {
    this.store.pipe(select(getProfileData))
      .pipe(distinctUntilChanged()).subscribe((res) => {
        if (res) {
          this.profileData = res;
        }
      })
  }


  public getPartnersInformationList(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNERS_INFORMATION);
    return this.http.get(url).pipe(
      map((response: any): PartnersInformation[] => {
        console.info(`Partner Information GET ( Received Partner Information `);
        return response?.data;
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`Partner Information( ${httpFaultMessage(fault, `HTTP ${fault?.status}`)} )`);
        this.toastService.showToast(fault?.error?.message || 'Error while fetching partner information list', 'error');
        return throwError(() => fault);
      })
    )
  }

  public getPartnersInformation(partnersUUID: string): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNERS_INFORMATION + '/' + partnersUUID);
    return this.http.get(url).pipe(
      map((response: any): PartnersInformation => {
        return response?.data;
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`Partner Information( ${httpFaultMessage(fault, `HTTP ${fault?.status}`)} )`);
        if(fault.status === 404) {
          this.router.navigate(['/partners'])
        }
        this.toastService.showToast(fault?.error?.message || 'Error while fetching partner information', 'error');
        return throwError(() => fault);
      })
    )
  }

  public contactPartners(contactFormData: ContactFormInfo, partnersUUID: string): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNERS_SUBMISSION + '/' + partnersUUID);
    return this.http.post(url, contactFormData).pipe(
      map((response: any): PartnersInformation => {
        return response;
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`Partner Information( ${httpFaultMessage(fault, `HTTP ${fault?.status}`)} )`);
        this.toastService.showToast(fault?.error?.message || 'Error while submitting contact data', 'error');
        return throwError(() => fault);
      })
    )
  }


  public getPartnerInformation(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNER_INFORMATION);
    return this.http.get(url).pipe(
      catchError((fault: HttpErrorResponse) => {
        this.toastService.showToast(this.globalService.getErrorMessage(fault, 'Error while getting partner info!'), 'error');
        return throwError(() => fault);
      })
    )
  }


  public addStartup(sttartup: IAddPartnerStartup): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNER_ADD_STARTUP);
    return this.http.post(url, sttartup).pipe(
      tap(() => {
        // this.getProfileCompleteness()
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`loginFault( ${fault.error?.message || fault.message || fault.status} )`);
        this.toastService.showToast(this.globalService.getErrorMessage(fault, 'Error while saving partner startup info!'), 'error');
        return throwError(() => fault);
      })
    );
  }

  public patchPartnerInfo(corporateInfo: PartnerInformationModel): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNER_INFORMATION);
    return this.http.patch(url, corporateInfo).pipe(
      tap(() => {
        this.getProfileCompleteness()
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`loginFault( ${fault.error?.message || fault.message || fault.status} )`);
        this.toastService.showToast(this.globalService.getErrorMessage(fault, 'Error while saving partner info!'), 'error');
        return throwError(() => fault);
      })
    );
  }

  public uploadLogo(logo: File, refetchProfile = false): Observable<any> {
    const payload = new FormData();
    payload.append('file', logo);
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNERS_LOGO_UPLOAD);
    console.info(`partner up logo`, payload);
    return this.http.post(url, payload).pipe(
      tap(() => {
        if (refetchProfile) {
          this.store.dispatch(new ProfileActions.GetProfile());
        }
        this.getProfileCompleteness()
      }),
      catchError((fault: HttpErrorResponse) => {
        this.toastService.showToast(this.globalService.getErrorMessage(fault, 'Error while uploading logo!'), 'error');
        console.warn(`save coporate Uplogo( ${httpFaultMessage(fault, `HTTP ${fault?.status}`)} )`);
        return throwError(() => fault);
      })
    );
  }

  public uploadInviteFile(file: File): Observable<any> {
    const payload = new FormData();
    payload.append('file', file);
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNERS_INVITE_CSV);
    return this.http.post(url, payload).pipe(
      tap(() => {
        // if (refetchProfile) {
        //   this.store.dispatch(new ProfileActions.GetProfile());
        // }
        this.getProfileCompleteness()
      }),
      catchError((fault: HttpErrorResponse) => {
        this.toastService.showToast(this.globalService.getErrorMessage(fault, 'Error while uploading file!'), 'error');
        return throwError(() => fault);
      })
    );
  }


  getProfileCompleteness() {
    return this.store.dispatch(new PartnerDashboardAction.GetProfileCompleteness());
  }

  public getPartnerCompleteness(): Observable<PartnerProfileCompleteness> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNER_PROFILE_COMPLETENESS);
    return this.http.get(url).pipe(
      map((response: any) => {
        return response.data;
      }),
      tap((res: any)=>{
        if(res?.isRejected){
          setTimeout(()=>{
            this.store.pipe(select(getBrandDetails)).pipe(take(1)).subscribe((res)=> {
              if(res) {
                if(res.features?.logout_on_rejection)  {
                  this.toastService.showToast('Your profile is rejected', 'error');
                  this.authService.logout();
                }
              }
            })
          }, 1000)
        }
      }),
      catchError((fault: HttpErrorResponse) => {
        return throwError(() => fault);
      })
    );
  }


  public sendApprovalRequest(): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.PARTNER_DASHBOARD_APPROVAL);
    return this.http.patch(url, {}).pipe(
      tap(() => this.getProfileCompleteness()),
      map((response: any) => {
        console.info(` sendApproval mentor GET ( send sendApproval mentorDashboard`);
        return response.message;
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`sendApproval( ${httpFaultMessage(fault, `HTTP ${fault?.status}`)} )`);
        return throwError(() => fault);
      })
    );
  }


  // public getServiceProviderDashboard(): Observable<any> {
  //   const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.SERVICE_PROVIDERS_DASHBOARD);
  //   return this.http.get(url).pipe(
  //     map((response: any) => {
  //       console.info(`getMentorDashboard GET ( Received getMentorDashboard `);
  //       return response.data;
  //     }),
  //     catchError((fault: HttpErrorResponse) => {
  //       this.toastService.showToast(this.globalService.getErrorMessage(fault, 'Error while fetching dashboard details!'), 'error');
  //       console.warn(`getMentorDashboard( ${fault.error.message} )`);
  //       return throwError(() => fault);
  //     })
  //   );
  // }

}
